import { JSX } from "react";

import {
  AttributeComponents,
  AttributeStrategy,
  CommonComponents,
  ConfigurationComponentType,
  ConfigurationComponents,
  ControlComponents,
  ControlComponentsMapping,
  LayoutComponentProvider,
  LayoutControlType,
} from "@plansoft-configuration-renderer/components";

import NavigationOutsideLayout from "./NavigationOutsideLayout";
import { CustomMarkdown } from "./components/CustomMarkdown/CustomMarkdown";
import { CustomCheckboxesMapper } from "./controls/CustomCheckboxes/CustomCheckboxesMapper";
import { CustomIndividualContainerMapper } from "./controls/CustomIndividualContainerMapper/CustomIndividualContainerMapper";
import { CustomRadio } from "./controls/CustomRadio";
import { CustomStandardPopover } from "./controls/CustomStandardPopover/CustomStandardPopover";
import { CustomSubConfigurationNavigation } from "./controls/CustomSubconfigurationNavigation/CustomSubconfigurationNavigation";
import { IndividualComponent } from "./controls/Individual";

// override control components for attributes
const controlComponents: ControlComponentsMapping = {
  ...ControlComponents, // the default components
  [LayoutControlType.Individual]: IndividualComponent, // override individual control
  [LayoutControlType.Radios]: CustomRadio, // override radio control
  [LayoutControlType.Checkboxes]: CustomCheckboxesMapper,
};

// override configuration level components
const configurationComponents = {
  ...ConfigurationComponents,
  [ConfigurationComponentType.ConfigurationTree]: NavigationOutsideLayout,
  [ConfigurationComponentType.SubconfigurationNavigation]:
    CustomSubConfigurationNavigation,
  [ConfigurationComponentType.IndividualContainer]:
    CustomIndividualContainerMapper,
};

// override attribute components
const attributeComponents = {
  ...AttributeComponents,
};

const commonComponents = {
  ...CommonComponents,
  Markdown: CustomMarkdown,
  StandardPopoverCloseButton: () => <></>,
  StandardPopover: CustomStandardPopover,
};

export function CustomRenderer(): JSX.Element {
  // see properties of LayoutComponentProvider for more information
  return (
    <LayoutComponentProvider
      configurationComponents={configurationComponents}
      attributeComponents={attributeComponents}
      controlComponents={controlComponents}
      commonComponents={commonComponents}
    >
      {/* Attribute strategy renders the components using the layout information */}
      <AttributeStrategy />
    </LayoutComponentProvider>
  );
}
